import React from 'react'

import { RadioContainer } from './styles'

interface RadioButtonProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  spanValue?: string
  ischeckboxvisible?: 'true' | 'false'
}

const RadioButton = (props: RadioButtonProps) => {
  const inputProps = { ...props }
  delete inputProps.spanValue

  return (
    <RadioContainer id="nova-shared-Radio-Button-root">
      <label className={`${props.disabled ? 'disabled' : ''}`}>
        {props.spanValue && (
          <span className={props.checked ? 'checked' : 'unchecked'}>
            <input
              {...inputProps}
              type={props.ischeckboxvisible === 'true' ? 'checkbox' : 'radio'}
              className={props.ischeckboxvisible === 'true' ? 'checkbox' : 'radio'}
            />
            {props.spanValue}
          </span>
        )}
      </label>
    </RadioContainer>
  )
}

export default RadioButton
